export const switchAppUrls = [
  'login',
  'recovery/password/confirm',
  'profile/new',
];
